import Vue from 'vue';
import Router from 'vue-router';
import * as config from './config/config';
import thisAuth from './utils/auth';
import Home from './views/Home.vue';
import InviteDetail from './views/InviteDetail.vue';
import ErrorView from './views/Error.vue';
import ExternalLogin from './views/external/Login.vue';
import Agent from './views/Agent.vue';
import DetailIndex from './views/external/DetailIndex.vue';
import Training from './views/external/Training.vue';
import TrainingDetail from './views/external/TrainingDetail.vue';
import Notice from './views/external/Notice.vue';
import Guide from './views/external/Guide.vue';
import Exam from './views/external/Exam.vue';
import KOToExternal from './views/KOToExternal.vue';
import { checkNested, getUrlKey } from './utils/utils';
import $ from 'jquery';
import SecurityIndex from './views/security/SecurityIndex.vue';
import VisitorCard from './views/security/VisitorCard.vue';
import NewCarrierVisit from './views/external/NewCarrierVisit.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/inviteDetail/:id',
      name: 'inviteDetail',
      component: InviteDetail,
    },
    {
      path: '/inviteAgreeToLeaveDetail/:id/:gate',
      name: 'inviteDetailGate',
      component: InviteDetail,
    },
    {
      path: '/chectoutremark/:id/:guardPostId/:targetDate',
      name: 'inviteDetailSpecial',
      component: InviteDetail,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorView,
    },
    {
      path: '/agent',
      name: 'agent',
      component: Agent,
    },
    {
      path: '*',
      redirect: {
        path: '/error',
        query: {
          message: 404,
        },
      },
    },
    {
      path: '/kovisitor/:id',
      name: 'koToExternal',
      component: KOToExternal,
    },
    {
      path: '/external/login',
      name: 'externalLogin',
      component: ExternalLogin,
      meta: { external: true },
    },
    {
      path: '/external/detailIndex/:id/:isNeedEffective',
      name: 'detailIndex',
      component: DetailIndex,
      meta: { external: true },
    },
    {
      path: '/external/carrier-new-application/:id/:isNeedEffective',
      name: 'carrierNewApplication',
      component: NewCarrierVisit,
      meta: {
        external: true
      },
    },
    {
      path: '/external/index/:id/:isNeedEffective',
      name: 'index',
      component: DetailIndex,
      meta: { external: true },
    },
    {
      path: '/external/training/:id/:categoryId',
      name: 'training',
      component: Training,
      meta: { external: true },
    },
    {
      path: '/external/trainingDetail/:id/:lessonId',
      name: 'trainingDetail',
      component: TrainingDetail,
      meta: { external: true },
    }, 
    {
      path: '/external/exam/:id/:lessonId/:examId',
      name: 'exam',
      component: Exam,
      meta: { external: true },
    },
    {
      path: '/external/notice/:id',
      name: 'notice',
      component: Notice,
      meta: { external: true },
    },
    {
      path: '/external/guide/:id',
      name: 'guide',
      component: Guide,
      meta: { external: true },
    },
    {
      path: '/redirect/*',
      meta: { redirect: true },
    },
    {
      path: '/security/:pathname',
      name: 'securityIndex',
      component: SecurityIndex,
      meta: { security: true },
    },
    {
      path: '/security/:pathname/:id',
      name: 'security',
      component: SecurityIndex,
      meta: { security: true },
    },
    {
      path: '/visitorCard/:id/:qrcode/:isNormal',
      name: 'visitorCard',
      component: VisitorCard,
    },
    {
      path: '/carrier/invitationlist/:id',
      name: 'pendingApproval',
      component: () => import('./views/koVisitor/ApplicationList.vue'),
      meta: {
        wechatwork: true
      },
    },
    {
      path: '/noRecord',
      name: 'koVisitorNorecord',
      component: () => import('./views/koVisitor/noRecord.vue'),
      wechatwork: true
    },
    {
      path: '/carrier/carlist',
      name: 'carlist',
      meta: {
        wechatwork: true
      },
      component: () => import('./views/koVisitor/carlist.vue'),
    },
    {
      path: '/carrier/invitationDetail/:id',
      name: 'approvalDetail',
      meta: {
        wechatwork: true
      },
      component: () => import('./views/koVisitor/Detail.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  const isWeixinBrowser = (/micromessenger/i).test(navigator.userAgent);
  const code = getUrlKey('code');
  const isExternal = to.meta.external;
  const debuglocal = getUrlKey('debuglocal');
  const urlName = to.name;
  const { redirect } = to.meta;
  const isSecurity = to.meta.security;
  const wechatwork = to.meta.wechatwork;

  // Remove modal before route change
  document.body.classList.remove('modal-open');

  sessionStorage.setItem('isExternal', isExternal);
  sessionStorage.setItem('backPath', from.path);

  if (to.name === 'error') {
    return next();
  }
  if (redirect) {
    return new Promise((resolve, reject) => $.getJSON(config.API.getRedirect(to.params.pathMatch)).then((res) => {
      if (checkNested(res, 'content', 'model')) {
        window.location.href = window.location.origin + res.content.model;
      } else {
        next({
          path: '/error',
        });
      }
    }));
  }
  if (debuglocal) {
    const userid = getUrlKey('userid');
    thisAuth.getAccessTokenDebug(userid, isExternal).then((model) => {
      const { origin, pathname } = window.location;
      thisAuth.setLocalAccessToken(model);
      if (isExternal) {
        window.location.href = `${origin}${pathname}`;
      } else if (config.APPID === '2' && !isSecurity) {
        window.location.href = `${origin}/security/index?mpWorkAppId=${config.MPWORKAPPID}&appId=${config.APPID}`;
      } else if (wechatwork) {
        if (model.role == 99) {
          next({
            path: '/noRecord',
          });
        } else {
          window.location.href = `${origin}${pathname}`;
        }
      } else {
        window.location.href = `${origin}${pathname}?mpWorkAppId=${config.MPWORKAPPID}&appId=${config.APPID}`;
      }
    }).catch((error) => {
      next({
        path: '/error',
        query: {
          message: error,
        },
      });
    });

    return false;
  }

  // If url from wechat redirect
  if (to.query.code) {
    thisAuth.getAccessToken(to.query.code).then((model) => {
      const { origin, pathname } = window.location;
      thisAuth.setLocalAccessToken(model);
      if (isExternal) {
        window.location.href = `${origin}${pathname}`;
      } else if (config.APPID === '2' && !isSecurity) {
        window.location.href = `${origin}/security/index?mpWorkAppId=${config.MPWORKAPPID}&appId=${config.APPID}`;
      } else if (wechatwork) {
        if (model.role == 99) {
          next({
            path: '/noRecord',
          });
        } else {
          // next();
          window.location.href =
            `${origin}${to.path}?mpWorkAppId=${config.MPWORKAPPID}&appId=${config.APPID}`;
        }
      } else {
        window.location.href = `${origin}${pathname}?mpWorkAppId=${config.MPWORKAPPID}&appId=${config.APPID}`;
      }
    }).catch((error) => {
      next({
        path: '/error',
        query: {
          message: error,
        },
      });
    });

    return false;
  }

  if (!isWeixinBrowser && !isExternal && urlName === 'home' && !thisAuth.isLogin()) {
    next({
      path: '/external/login'
    });
  }

  if (isWeixinBrowser && !thisAuth.isLogin() && !isExternal && urlName !== 'visitorCard') {
    thisAuth.goLogin();
    return false;
  }

  

  if (isWeixinBrowser && !isExternal && urlName !== 'visitorCard') {
    if (thisAuth.checkToken()) {
      thisAuth.getRefreshAccessToken().then((model) => {
        thisAuth.setLocalAccessToken(model);
        if (config.APPID === '2' && !isSecurity) {
          next({
            path: '/security/index',
            query: to.query,
          });
        } else if (wechatwork) {
          if (model.role == 99) {
            next({
              path: '/noRecord',
            });
          } else {
            //- next();
            window.location.href =
            `${origin}${to.path}?mpWorkAppId=${config.MPWORKAPPID}&appId=${config.APPID}`;
          }
        } else {
          next();
        }
      }).catch((error) => {
        if (config.APPID === '4') {
          next({
            path: '/carrier/invitationlist/0',
          });
        } else {
          next({
            path: '/error',
            query: {
              message: error,
            },
          });
        }
      });
    } else {
      if (config.APPID === '2' && !isSecurity) {
        next({
          path: '/security/index',
          query: to.query
        });
      } else {
        next();
      }
    }


    return false;
  }

  if (isExternal && urlName !== 'externalLogin' && urlName != "visitorCard") {
    const redirectUri = to.path;
    var query = to.query;
    query.redirect_uri = redirectUri;
    const routId =  to.params.id;
    if (!thisAuth.isLogin()) {
      next({
        path: '/external/login',
        query: query,
      });
    } else {
      if (thisAuth.checkToken()) { // token expire
          thisAuth.getRefreshAccessTokenExternal().then((model) => {
          thisAuth.setLocalAccessToken(model);
          next();
        }).catch((error) => {
          query.message = error;
          if (urlName != "index") {
            next({
              path: '/external/login',
              query: query,
            });
          } else {
            if (routId) {
              next({
                path:  `/kovisitor/${routId}?mpWorkAppId=1&appId=1`,
                query: query,
              });
            } else {
              next({
                path:  `/kovisitor/0?mpWorkAppId=1&appId=1`,
                query: query,
              });
            }
          }
         
        });
      } else {
        next();
      }  
    }
    return false;
  }

  if (isExternal && !to.query.message && urlName === 'externalLogin' && thisAuth.isLogin()  && urlName != "visitorCard") {
    var query = to.query;
    if (thisAuth.checkToken()) {
      thisAuth.getRefreshAccessTokenExternal().then((model) => {
        const uri = to.query.redirect_uri == undefined ? '/external/detailIndex/0/0' : to.query.redirect_uri;
        if (query['redirect_uri']) {
          delete query['redirect_uri'];
        }
        thisAuth.setLocalAccessToken(model);
        next({
          path: uri,
          query: query,
        });
      }).catch((error) => {
        query.message = error;
        next({
          path: '/external/login',
          query: query,
        });
      });
    } else {
      const uri = to.query.redirect_uri == undefined ? '/external/detailIndex/0/0' : to.query.redirect_uri;
      if (query['redirect_uri']) {
        delete query['redirect_uri'];
      }
      next({
        path: uri,
        query: query,
      });
    }

    return false;
  }

  return next();
});

export default router;
